<template>
  <component :is="'h' + level" :class="classes">
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import type { IHeadingLevel, IHeadingVariant } from './ui-heading-types';

interface Props {
  level?: IHeadingLevel;
  variant?: IHeadingVariant;
}

const props = withDefaults(defineProps<Props>(), {
  level: 1,
  variant: 'default',
});

const sizeMap: Record<IHeadingLevel, string> = {
  '1': 'text-xl md:text-2xl',
  '2': 'text-lg md:text-xl',
  '3': 'text-base',
  '4': 'text-sm',
  '5': 'text-xs',
  '6': 'text-xxs',
};

const classes = computed(() => {
  const nextClasses: string[] = ['leading-tight', 'text-app-black'];

  switch (props.variant) {
    case 'default':
      nextClasses.push('font-medium normal-case');
      break;
    case 'bold':
      nextClasses.push('font-bold normal-case');
      break;
    case 'uppercase':
      nextClasses.push('font-medium uppercase tracking-wider');
      break;
  }

  nextClasses.push(sizeMap[(props.level + '') as IHeadingLevel]);
  return nextClasses;
});
</script>
